import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import DisableDevtool from 'disable-devtool';

Vue.use(ElementUI)

import router from './router'
Vue.config.productionTip = false
//禁用浏览器控制台
if (process.env.NODE_ENV === 'production') {
	DisableDevtool({
		url: "",
		disableMenu: false,
		tkName: "ddtk",
		md5: "918b3187d8c7199016d0535d6cd275fb"
	});
}

new Vue({
	router,
	render: h => h(App),
}).$mount('#app')
